import { createBackgroundRefresh, isBackgroundRefreshPaused } from "./backgroundRefresh";

type RefreshableQuery = { isActive(): boolean; isDisabled(): boolean; fetch(): Promise<unknown> };
const refreshes = new WeakMap<RefreshableQuery, ReturnType<typeof createBackgroundRefresh>>();

/** Query focus/reconnect policy without pausing mutation retryers or action requests. */
export function backgroundQueryRefresh(query: RefreshableQuery, policy: boolean | "always" = true): boolean | "always" {
  if (!isBackgroundRefreshPaused()) return policy;
  if (policy === false) return false;
  let refresh = refreshes.get(query);
  if (!refresh) {
    refresh = createBackgroundRefresh(() => {
      refreshes.delete(query);
      if (query.isActive() && !query.isDisabled()) void query.fetch().catch(() => { /* Query owns the error state. */ });
    });
    refreshes.set(query, refresh);
  }
  refresh.request();
  return false;
}
